// apps/web/src/routes/dashboard.tsx
import useSWR from 'swr'
import { Card, CardContent, CardHeader } from '@viecxanh/chat-ui/card'
import { Skeleton } from '@viecxanh/chat-ui/skeleton'
import { api } from '../lib/api-client'
import type { AdminStats } from '@viecxanh/chat-shared'

interface StatCardProps {
  label: string
  value: string | number
  sub?: string
  loading?: boolean
}

function StatCard({ label, value, sub, loading }: StatCardProps) {
  return (
    <Card>
      <CardHeader className="pb-1">
        <p className="text-sm text-slate-500">{label}</p>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Skeleton className="h-8 w-24" />
        ) : (
          <>
            <p className="text-3xl font-bold">{value}</p>
            {sub && <p className="text-xs text-slate-400 mt-0.5">{sub}</p>}
          </>
        )}
      </CardContent>
    </Card>
  )
}

export function DashboardPage() {
  const { data, isLoading } = useSWR<AdminStats>(
    '/api/admin/stats',
    (url: string) => api.get<AdminStats>(url),
    { refreshInterval: 30_000 },
  )

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-xl font-semibold">Tổng quan</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Hội thoại hôm nay" value={(data as any)?.total_resolved_today ?? (data as any)?.conversations_today ?? 0} loading={isLoading} />
        <StatCard label="Đang mở" value={(data as any)?.total_open ?? (data as any)?.open_conversations ?? 0} loading={isLoading} />
        <StatCard
          label="Thời gian phản hồi TB"
          value={(data as any)?.avg_response_time_minutes ? `${(data as any).avg_response_time_minutes} phút` : '—'}
          loading={isLoading}
        />
        <StatCard label="Kênh hoạt động" value={(Object.keys((data as any)?.by_channel ?? {}).length) || ((data as any)?.active_channels ?? 0)} loading={isLoading} />
      </div>
    </div>
  )
}
